<template>
  <div id="messageDetailsBox">
    <div class="title">
      <img src="../../assets/image/icon_zzjj@2x.png" alt />
      <h3>公告详情</h3>
    </div>
    <div class="tableContainer">
      <div>
        <div class="headerRow">
          <div class="messageTitle">{{$store.state.process.message.messageDetails.title}}</div>
          <el-button @click="goBack" class="backBtn">返回</el-button>
        </div>
        <!-- <div style="height:150vh;background:red"></div> -->
        <div v-html="$store.state.process.message.messageDetails.content"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
  },
  created() {},
}
</script>
<style lang="less" scoped>
#messageDetailsBox {
  width: 100%;
  height: 92%;
  box-sizing: border-box;
  padding: 0 3.5%;
  .title {
    display: flex;
    align-items: center;
    padding: 30px 0 20px;
    img {
      display: block;
      width: 31px;
      margin-right: 20px;
    }
    h3 {
      font-size: 28px;
      font-weight: 400;
      color: #333;
    }
  }
  .tableContainer {
    width: 100%;
    border-radius: 10px;
    height: calc(100% - 90px - 30px);
    overflow-y: scroll;
    background-color: #fff;
    box-sizing: border-box;
    padding: 0 40px;
    padding-top: 20px;
    .headerRow {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 46px;
      position: relative;
      .backBtn {
        position: absolute;
        right: 20px;
        height: 32px;
        width: 80px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .messageTitle {
        font-size: 20px;
        color: #333;
        font-weight: 700;
      }
    }
  }
}
</style>
